export default {
 SET_EMAIL_SEARCH_QUERY(state, query) {
  state.mailSearchQuery = query
 },
 SET_MAILS(state, mails, filter) {
  state.mails = state.mails.concat(mails);
 },
 SET_MAILS_EMPTY(state) {
  state.mails = [];
 },
 SET_MAIL_SKIP(state, mailSkip) {
  state.mailSkip = mailSkip;
 },
 SET_MAIL_TOP(state, mailTop) {
  state.mailTop = mailTop;
 },
 SET_MAIL_LOADING(state, mailLoading) {
  state.mailLoading = mailLoading;
 },
 SET_MAIL_UPDATING(state, mailUpdating) {
  state.mailUpdating = mailUpdating;
 },
 SET_MAIL_END(state, mailEnd) {
  state.mailEnd = mailEnd;
 },
 SET_TAGS(state, tags) {
  state.mailTags = tags
 },
 SET_META(state, meta) {
  state.meta = meta
 },
 SET_FOLDERS(state, pmailFolders) {
  let focusedFolders = [];
  let mailFolders = pmailFolders.map(function (elem) {
   switch (elem.displayName) {
    case 'Inbox':
     elem.icon = "MailIcon";
     elem.realName = "Inbox";
     state.inboxFolderId = elem.id;
     break;
    case 'Sent Items':
     elem.icon = "SendIcon";
     elem.realName = "Sent";
     state.sentFolderId = elem.id;
     break;
    case 'Drafts':
     elem.icon = "Edit2Icon";
     elem.realName = "Draft";
     state.draftFolderId = elem.id;
     break;
    case 'Junk Email':
     elem.icon = 'InfoIcon';
     elem.realName = "Spam";
     state.spamFolderId = elem.id;
     break;
    case 'Deleted Items':
     elem.icon = 'TrashIcon';
     elem.realName = "Trash";
     state.trashFolderId = elem.id;
     break;
    default:
     elem.icon = 'FolderIcon';
     elem.realName = elem.displayName;
    
   }
   return elem;
  });
  focusedFolders.push(mailFolders.filter(function (elem) {
   return elem.displayName === "Inbox";
  })[0]);
  focusedFolders.push(mailFolders.filter(function (elem) {
   return elem.displayName === "Sent Items";
  })[0]);
  focusedFolders.push(mailFolders.filter(function (elem) {
   return elem.displayName === "Drafts";
  })[0]);
  focusedFolders.push(mailFolders.filter(function (elem) {
   return elem.displayName === "Junk Email";
  })[0]);
  focusedFolders.push(mailFolders.filter(function (elem) {
   return elem.displayName === "Deleted Items";
  })[0]);
  
  let otherFolderList = [];
  
  for (let i = 0; i < pmailFolders.length; i++) {
   pmailFolders[i]['style'] = "margin-left: 0px;";
   otherFolderList.push(pmailFolders[i]);
   if (pmailFolders[i]['children']) {
    for (let j = 0; j < pmailFolders[i]['children'].length; j++) {
     pmailFolders[i]['children'][j]['style'] = "margin-left: 15px;";
     otherFolderList.push(pmailFolders[i]['children'][j]);
     if (pmailFolders[i]['children'][j]['children']) {
      for (let k = 0; k < pmailFolders[i]['children'][j]['children'].length; k++) {
       pmailFolders[i]['children'][j]['children'][k]['style'] = "margin-left: 30px;";
       otherFolderList.push(pmailFolders[i]['children'][j]['children'][k]);
       if (pmailFolders[i]['children'][j]['children'][k]['children']) {
        for (let m = 0; m < pmailFolders[i]['children'][j]['children'][k]['children'].length; m++) {
         pmailFolders[i]['children'][j]['children'][k]['children'][m]['style'] = "margin-left: 45px;";
         otherFolderList.push(pmailFolders[i]['children'][j]['children'][k]['children'][m]);
        }
       }
      }
     }
    }
   }
  }
  state.mailFolders.focused = focusedFolders;
  state.mailFolders.others = otherFolderList;
 },
 UPDATE_MAIL_FILTER(state, filterName) {
  state.mail_filter = filterName
 },
 UPDATE_LABELS(state, payload) {
  payload.mails.forEach((mailId) => {
   const mailIndex = state.mails.findIndex((mail) => mail.id === mailId);
   const index = state.mails[mailIndex].labels.indexOf(payload.label);
   
   if (index === -1) state.mails[mailIndex].labels.push(payload.label);
   else state.mails[mailIndex].labels.splice(index, 1);
  })
 },
 SET_LABELS(state, payload) {
  state.mails.find((mail) => mail.id === payload.mailId).labels = payload.labels;
 },
 SET_UNREAD(state, payload) {

 },
 
 MOVE_MAILS_TO(state, payload) {

 },
 
 TOGGLE_IS_MAIL_STARRED(state, payload) {
  state.mails.find((mail) => mail.id === payload.mailId).isStarred = payload.value;
 },
 UPDATE_UNREAD_META(state, payload) {

 },
 UPDATE_UNREAD_META_ON_MOVE(state, payload) {

 }
}
